import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
  } from 'amazon-cognito-identity-js'
  import { Config } from 'aws-sdk'
  
  export default class Cognito {
    configure (config) {
      if (config.userPool) {
        this.userPool = config.userPool
      } else {
        this.userPool = new CognitoUserPool({
          UserPoolId: config.UserPoolId,
          ClientId: config.ClientId
        })
      }
      Config.region = config.region
      this.options = config
    }
  
    static install = (Vue, options) => {
      Object.defineProperty(Vue.prototype, '$cognito', {
        get () { return this.$root._cognito }
      })
  
      Vue.mixin({
        beforeCreate () {
          if (this.$options.cognito) {
            this._cognito = this.$options.cognito
            this._cognito.configure(options)
          }
        }
      })
    }
  
    /**
     * employee id, passwordでログイン
     */
    login (username, password) {
      const userData = { Username: username, Pool: this.userPool }
      const cognitoUser = new CognitoUser(userData)
      const authenticationData = { Username: username, Password: password }
      const authenticationDetails = new AuthenticationDetails(authenticationData)
      return new Promise((resolve, reject) => {
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: (result) => {
            resolve(result)
          },
          onFailure: (err) => {
            alert('社員番号もしくはパスワードに誤りがあります')
            reject(err)
          },
          newPasswordRequired(userAttributes, requiredAttributes) {
            // 初回ログイン時に入力されたパスワードをそのまま使用
            cognitoUser.completeNewPasswordChallenge(password, {}, this)
          }
        })
      })
    }

    /**
     * logout
     */
    logout () {
      if (this.userPool.getCurrentUser()) {
        this.userPool.getCurrentUser().signOut()
      } else {
        // nop
      }
    }
  
    /**
     * check login
     */
    isAuthenticated () {
      const cognitoUser = this.userPool.getCurrentUser()
      return new Promise((resolve, reject) => {
        if (cognitoUser === null) { reject(cognitoUser) }
        cognitoUser.getSession((err, session) => {
          if (err) {
            reject(err)
          } else {
            if (!session.isValid()) {
              console.log('Session inValid')
              reject(session)
            } else {
              console.log('Session Valid')
              resolve(session)
            }
          }
        })
      })
    }

    /**
     * ログインの後処理
     */
    postLoginSuccess (result) {
      document.cookie = `cgnt-id-token=${result.getIdToken().getJwtToken()}; Domain=${location.hostname}; Max-Age=60; Secure;`
      var url = `https://${location.hostname}/post_login`
      var request = new XMLHttpRequest()
      request.open('GET', url)
      request.send()
      request.onreadystatechange = function() {
        if (request.readyState == 4) {
          if (request.status == 200) {
            const contentsLocation = JSON.parse(request['response'])['contentsUrl']
            location.href = contentsLocation
          } else if (request.status == 403) {
            alert('Unauthorized')
          } else {
            alert('Internal Server Error')
          }
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/cognito/cognito.js